import React, { useState, useRef, useEffect } from "react";
import { SERVICE_DROPDOWN } from "../data/siteData";

const SERVICE_IDS = SERVICE_DROPDOWN.map((s) => s.id);

export default function Navbar({ currentPage, onNavigate }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [mobileServiceOpen, setMobileServiceOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const closeTimer = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isServiceActive = SERVICE_IDS.includes(currentPage);

  const go = (page) => {
    onNavigate(page);
    setMobileOpen(false);
    setDropdown(false);
    setMobileServiceOpen(false);
  };

  const openDropdown = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setDropdown(true);
  };

  const closeDropdown = () => {
    closeTimer.current = setTimeout(() => setDropdown(false), 150);
  };

  return (
    <nav className={`navbar${scrolled ? " navbar-scrolled" : ""}`}>
      <div className="navbar-inner">
        {/* Logo */}
        <div className="logo" onClick={() => go("home")} style={{ cursor: "pointer" }}>
          <img src="/assets/logo.png" alt="" className="logo-icon-img" />
          <span className="logo-text">Rising Sun</span>
        </div>

        {/* Desktop Nav */}
        <ul className="nav-links">
          <li
            className={`nav-item ${isServiceActive || dropdown ? "active" : ""}`}
            onMouseEnter={openDropdown}
            onMouseLeave={closeDropdown}
          >
            <span onClick={() => go("software")}>Services</span>
            <span className="nav-arrow">▾</span>
            {dropdown && (
              <div
                className="dropdown"
                onMouseEnter={openDropdown}
                onMouseLeave={closeDropdown}
              >
                <div className="dropdown-arrow" />
                <p className="dropdown-heading">Our Services</p>
                <div className="dropdown-grid">
                  {SERVICE_DROPDOWN.map((s) => (
                    <div
                      key={s.id}
                      className={`dropdown-item ${currentPage === s.id ? "active" : ""}`}
                      onClick={() => go(s.id)}
                    >
                      <span className="dropdown-item-icon">{s.icon}</span>
                      <span className="dropdown-item-label">{s.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </li>
          <li
            className={`nav-item ${currentPage === "about" ? "active" : ""}`}
            onClick={() => go("about")}
          >
            <span>About</span>
          </li>
          <li
            className={`nav-item ${currentPage === "portfolio" ? "active" : ""}`}
            onClick={() => go("portfolio")}
            style={{ display: "none" }}
          >
            <span>Case Studies</span>
          </li>
          <li
            className={`nav-item ${currentPage === "solutions" ? "active" : ""}`}
            onClick={() => go("solutions")}
          >
            <span>Technology Solutions</span>
          </li>
          <li
            className={`nav-item ${currentPage === "contact" ? "active" : ""}`}
            onClick={() => go("contact")}
          >
            <span>Contact</span>
          </li>
        </ul>

        {/* CTA */}
        <button className="btn-know-more desktop-cta" onClick={() => go("contact")}>
          <span className="btn-text-default">Get Started</span>
          <span className="btn-text-hover">Get Started</span>
        </button>

        {/* Hamburger */}
        <button
          className={`hamburger ${mobileOpen ? "open" : ""}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile */}
      <div className={`mobile-overlay ${mobileOpen ? "show" : ""}`} onClick={() => setMobileOpen(false)} />
      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
        <ul className="mobile-nav-links">
          <li className="mobile-nav-item">
            <span className={`mobile-nav-link ${currentPage === "home" ? "active" : ""}`} onClick={() => go("home")}>Home</span>
          </li>
          <li className="mobile-nav-item">
            <span className="mobile-nav-link" onClick={() => setMobileServiceOpen(!mobileServiceOpen)}>
              Services
              <span className={`mobile-arrow ${mobileServiceOpen ? "rotated" : ""}`}>▸</span>
            </span>
            {mobileServiceOpen && (
              <ul className="mobile-sub-menu">
                {SERVICE_DROPDOWN.map((s) => (
                  <li key={s.id} className={currentPage === s.id ? "active" : ""} onClick={() => go(s.id)}>{s.label}</li>
                ))}
              </ul>
            )}
          </li>
          <li className="mobile-nav-item">
            <span className={`mobile-nav-link ${currentPage === "about" ? "active" : ""}`} onClick={() => go("about")}>About</span>
          </li>
          <li className="mobile-nav-item" style={{ display: "none" }}>
            <span className={`mobile-nav-link ${currentPage === "portfolio" ? "active" : ""}`} onClick={() => go("portfolio")}>Case Studies</span>
          </li>
          <li className="mobile-nav-item">
            <span className={`mobile-nav-link ${currentPage === "solutions" ? "active" : ""}`} onClick={() => go("solutions")}>Technology Solutions</span>
          </li>
          <li className="mobile-nav-item">
            <span className={`mobile-nav-link ${currentPage === "contact" ? "active" : ""}`} onClick={() => go("contact")}>Contact</span>
          </li>
        </ul>
        <button className="btn-know-more mobile-cta" onClick={() => go("contact")}>
          <span className="btn-text-default">Get Started</span>
          <span className="btn-text-hover">Get Started</span>
        </button>
      </div>
    </nav>
  );
}
